import { IAttendeeOrganizationDTO } from './attendees.dao';
import { Access, MeetingStatus } from './meetings.dao';

abstract class IAIFeatureDAO {
    public abstract generatePassportBackground(params: IGeneratePassportBackgroundMessageParams): Promise<void>;
    public abstract getMeetingsGenerationIdentifier(params: IUrlRequestParams): Promise<IMeetingGenerationIdentifierResponse>;
    public abstract generateMeetingsData(params: IGenerateMeetingsDataParams): Promise<void>;
}

interface IUrlRequestParams {
    accountId: number;
    eventId: number;
}

interface IGeneratePassportBackgroundMessageParams extends IUrlRequestParams {
    prompt: string;
    size?: string;
    images?: number;
}

interface IOnPassportBackgroundGenerationCompleted {
    eventId: number;
    imageUrl: string;
    objectKey: string;
}

interface IOnPassportBackgroundGenerationCompletedResponse {
    value: {
        data: {
            onPassportBackgroundGenerationCompleted: IOnPassportBackgroundGenerationCompleted;
        };
    };
}

interface IMeetingGenerationIdentifierResponse {
    identifier: string;
}

interface IGenerateMeetingsDataParams extends IUrlRequestParams {
    identifier: string;
    prompt: string;
}

interface IGeneratedMeeting {
    startDateTime: string;
    endDateTime: string;
    meetingAccess: Access;
    status: MeetingStatus;
    topic: string;
    type: string;
    participants: IAttendeeOrganizationDTO[];
    presenters: IAttendeeOrganizationDTO[];
    registrants: IAttendeeOrganizationDTO[];
    supports: IAttendeeOrganizationDTO[];
    hosts: IAttendeeOrganizationDTO[];
}

interface IOnMeetingsCreateDataGenerationCompleted extends IMeetingGenerationIdentifierResponse {
    aiResponse: IGeneratedMeeting[];
}

interface IOnMeetingsCreateDataGenerationCompletedResponse {
    value: {
        data: {
            onMeetingsCreateDataGenerationCompleted: IOnMeetingsCreateDataGenerationCompleted;
        };
    };
}

export {
    IAIFeatureDAO,
    IGeneratePassportBackgroundMessageParams,
    IOnPassportBackgroundGenerationCompletedResponse,
    IOnPassportBackgroundGenerationCompleted,
    IUrlRequestParams,
    IMeetingGenerationIdentifierResponse,
    IGenerateMeetingsDataParams,
    IOnMeetingsCreateDataGenerationCompletedResponse,
    IGeneratedMeeting
};
